import { SharedCostRuleComponent } from '../shared-cost-rule.component';
import { SCRFocusStrategy } from './scr-focus-strategy.interface';
import { SharedCostRuleFieldType } from 'app/shared/types/shared-cost-rule.interface';

export class SCRBudgetFocusStrategy implements SCRFocusStrategy {
  componentInstance: SharedCostRuleComponent;

  constructor(componentInstance: SharedCostRuleComponent) {
    this.componentInstance = componentInstance;
  }

  activate() {
    const isCurrentDropdownActive = this.componentInstance.isActiveDropdown(SharedCostRuleFieldType.Budget);
    if (!isCurrentDropdownActive) {
      this.componentInstance.resetActiveDropdown();
    }
    this.componentInstance.currentFocusStrategy = this;
    this.componentInstance.focusedFieldType = SharedCostRuleFieldType.Budget;
    this.componentInstance.focusedSegmentIndex = -1;
    this.componentInstance.focusElement(this.componentInstance.budgetElement);
  }

  moveFocus(isForward: boolean) {
    const { focusStrategies } = this.componentInstance;
    if (isForward) {
      focusStrategies[SharedCostRuleFieldType.Name].activate();
    } else {
      focusStrategies[SharedCostRuleFieldType.Status].activate();
    }
  }

  selectElement() {
    if (!this.componentInstance.permissions.editRule) {
      return;
    }
    this.componentInstance.toggleActiveDropdown(SharedCostRuleFieldType.Budget);
  }

  unselectElement() {
    this.componentInstance.resetActiveDropdown();
  }
}
